<template>
    <div>
        <draggable
            class="drag-drop"
            :list="attributes.values"
            v-bind="dragOptions"
            @change="save"
            @start="drag = true"
            @end="drag = false"
        >
            <div v-for="(value, i) in attributes.values" :key="i" class="drag-drop__item drag-drop__item--sm">
                <span class="drag-drop__handle">
                    <i class="ak-icon ak-table-row__handle">drag_indicator</i>
                </span>
                <img :src="value.href" alt="">
            </div>
        </draggable>
        <div v-if="attributes && attributes.helpText"  class="form__help" v-html="attributes.helpText"></div>
        <div v-if="attributes.hasError" class="form__error">
            <span class="icon-alert"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
            <span v-html="attributes.error"></span>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
    props: ['attributes'],
    data() {
        return {
            drag: false,
        }
    },
    computed: {
        dragOptions() {
            return {
                animation: 200,
                disabled: false,
                ghostClass: "drag-drop__item--dragging"
            };
        }
    },
    methods: {
        save(e) {
            this.$emit('input', this.attributes.values);
            this.$emit('updateState', this.attributes.values);
        }
    },
    components: {
        draggable,
    },

}
</script>
